import Immutable from 'immutable';
import {
  FLAG_GETTING_EXTRAORDINARY_MOVEMENT_CONTROLS,
  GET_EXTRAORDINARY_MOVEMENT_CONTROLS,
  CLEAR_EXTRAORDINARY_MOVEMENT_CONTROLS,
  FLAG_EXTRAORDINARY_MOVEMENT_CONTROL_ACTIVITY,
  GET_EXTRAORDINARY_MOVEMENT_CONTROL,
  CLEAR_EXTRAORDINARY_MOVEMENT_CONTROL,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_EXTRAORDINARY_MOVEMENT_CONTROLS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_EXTRAORDINARY_MOVEMENT_CONTROLS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_EXTRAORDINARY_MOVEMENT_CONTROLS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_EXTRAORDINARY_MOVEMENT_CONTROL_ACTIVITY:
      // raising flag
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_EXTRAORDINARY_MOVEMENT_CONTROL:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_EXTRAORDINARY_MOVEMENT_CONTROL:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
